import { useWatch } from 'react-hook-form';
import { useCompanyContext } from '../../../../context/CompanyContext';
import { CLAIM_STATUS, ClaimFiltersOptions } from '../ClaimFilters';

const ClaimReportHeader = () => {
  const { selectedCompany } = useCompanyContext();
  const filters = useWatch<ClaimFiltersOptions>();

  return (
    <div className="blackText printMedia printShow">
      <div className="text-30px text-center mt-5">{selectedCompany!.name}</div>
      <div className="text-28px text-center">Claim Report</div>
      <div className="text-17px ml-3 mt-2">
        <span className="font-bold text-20px">Search criteria:</span>
        <div className="ml-3">
          <div>
            <span className="font-bold mr-1">Status:</span>
            {
              CLAIM_STATUS.find(
                (status) => status.value === filters.claimStatus
              )?.label
            }
          </div>
        </div>
      </div>
      <div className="ml-3 text-17px mb-5">
        <span className="font-bold mr-1">Created at:</span>
        {new Date().toLocaleString()}
      </div>
    </div>
  );
};

export default ClaimReportHeader;
